import { alpha, styled } from '@mui/material'
import { FlexCenter, FlexStart, themeValue } from 'styles'

export const MarketSelectorWrap = styled(FlexStart)`
  height: 100%;
  cursor: pointer;
  position: relative;
  /* ${(props) => props.theme.breakpoints.up('md')} {
    &:hover {
      .market-select {
        display: block;
      }
    }
  } */
`
export const SymbolArrowDown = styled('span')<{ visible: string }>`
  margin: 0 8px;
  line-height: 0;
  color: ${({ theme, visible }) =>
    visible === '2' ? theme.color.text50 : theme.color.primary30};
  svg {
    transition: transform 0.4s ease;
    transform: ${(props) =>
      props.visible === '1' ? 'rotate(-180deg)' : 'rotate(0deg)'};
  }
`
export const SymbolsDropdownWrap = styled('div')`
  position: absolute;
  top: 100%;
  left: -20px;
  padding: 8px 0 16px;
  background: ${themeValue('rgba(30, 35, 41, 1)', 'rgba(249, 249, 250, 1)')};
  min-width: 320px;
  max-height: 560px;
  border-radius: 0 0 4px 4px;
  box-shadow: 0px 4px 8px 0px rgba(0, 0, 0, 0.25);
  z-index: 5;
  overflow-y: auto;
`
export const FilterInput = styled('label')`
  display: block;
  height: 40px;
  margin: 0 12px;
  position: relative;

  @keyframes anim {
    0% {
      width: 0;
    }
    100% {
      width: 100%;
    }
  }

  &:focus-within {
    &::after {
      content: '';
      position: absolute;
      left: 0;
      width: 0;
      bottom: 0px;
      height: 1px;
      background-color: ${(props) => props.theme.color.primary30};
      animation: anim 0.3s ease-in-out;
      animation-fill-mode: forwards;
    }
  }
`
export const Icon = styled(FlexCenter)`
  width: 24px;
  position: absolute;
  left: 0;
  top: 50%;
  transform: translateY(-50%);
  .iconfont {
    margin-top: -2px;
    color: ${(props) => props.theme.color.text40};
  }
`
export const Input = styled('input')`
  height: 100%;
  padding: 0 12px 0 28px;
  border: none;
  font-size: 14px;
  border-bottom: 1px solid ${(props) => props.theme.color.text20};
  box-sizing: border-box;
  background-color: transparent;
  color: ${(props) => props.theme.color.text90};
  outline: none;
  width: 100%;
  position: relative;
  &::placeholder {
    color: ${(props) => props.theme.color.text40};
  }

  /* &:focus {
    border-bottom-color: ${(props) => props.theme.color.primary30};
  } */
`
export const SymbolListWrap = styled('div')`
  margin-top: 16px;
`
export const SymbolListHeader = styled('div')`
  display: grid;
  grid-template-areas: 'pair price change';
  grid-template-columns: 130px auto 50px;
  gap: 12px;
  color: ${(props) => props.theme.color.text40};
  font-size: 12px;
  line-height: 16px;
  padding: 0 16px;
`
export const SymbolListContent = styled('div')`
  margin-top: 2px;
`
export const SymbolRow = styled(SymbolListHeader)`
  height: 50px;
  align-items: center;
  font-size: 14px;
  padding: 0 12px;
  margin-top: 8px;
  color: ${(props) => props.theme.color.text70};

  &:hover {
    background: ${(props) => alpha(props.theme.color.text20, 0.5)};
    > div:first-of-type {
      color: ${(props) => props.theme.color.primary30};
    }
    .iconfont {
      visibility: visible;
    }
  }
`
export const PairColumn = styled(FlexStart)`
  grid-area: pair;
  white-space: nowrap;
  img {
    flex-shrink: 0;
    width: 24px;
    height: 24px;
    border-radius: 16px;
    overflow: hidden;
    display: block;
    margin-right: 8px;
  }
  .iconfont {
    font-weight: bold;
    margin-left: 2px;
    visibility: hidden;
  }
`
export const PriceColumn = styled('div')`
  grid-area: price;
  white-space: nowrap;
`
export const ChangeColumn = styled('div')`
  grid-area: change;
  text-align: right;
  white-space: nowrap;
`
export const MarketIconWrap = styled('div')`
  position: relative;
  svg {
    position: absolute;
    top: -4px;
    right: 2px;
  }
`
